// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { createMetricAlert, deleteMetricAlert, setAlertNotes, disableMetricAlert, enableMetricAlert, } from './metric-alert-items.actions';
import { setAlertFetchSuccess } from 'AlertsApp/ts/features/alerts-modals/state/alert-modal-status/alert-modal-status.actions';
// Constants
import { METRIC_ALERT_LIMIT } from 'AlertsApp/ts/features/alerts-modals/constants';
export const metricAlertItems = createReducer([], on(setAlertFetchSuccess, (state, action) => {
    // @ts-ignore
    return action.alerts.filter((alert) => alert.alert_type === METRIC_ALERT_LIMIT);
}), on(createMetricAlert, (state, action) => {
    return [...state, action.alert];
}), on(deleteMetricAlert, (state, action) => {
    return state.filter((alert) => {
        // alerts are unique based on id, alert type, and object type
        return !(alert.id === action.alert.id &&
            alert.alert_type === action.alert.alert_type &&
            alert.object_type === action.alert.object_type);
    });
}), on(setAlertNotes, (state, action) => {
    return state.map((alert) => {
        if (alert.id === action.alert.id) {
            return { ...alert, notes: action.notes };
        }
        return alert;
    });
}), on(enableMetricAlert, (state, action) => {
    return state.map((alert) => {
        if (alert.id === action.alert.id) {
            return { ...alert, disabled_alert_preference_id: undefined };
        }
        return alert;
    });
}), on(disableMetricAlert, (state, action) => {
    return state.map((alert) => {
        if (alert.id === action.alert.id) {
            return { ...alert, disabled_alert_preference_id: action.disabledAlertPreferenceId };
        }
        return alert;
    });
}));
